






















































import VueOptions from '@utils/VueOptions'

settings =
  name: 'ShoppingCartTableView'

  vue:
    props: ['lineItems', 'wizard', 'options']

    computed:
      isSavedItem: -> @options?.savedItemsList
      enabledActions: -> @options?.enabledActions
      emptyMessage: -> @options?.emptyMessage || 'Your cart is empty'

    methods:
      formatDateForEvent: (event) ->
        localStartDay = @$options.filters.formatDate(event.local_start_day, 'MM/DD/YYYY')
        localStartTime = @$options.filters.formatTime(event.local_start_time)

        localEndDay = @$options.filters.formatDate(event.local_end_day, 'MM/DD/YYYY')
        localEndTime = @$options.filters.formatTime(event.local_end_time)

        if @isSingleDayEvent
           "#{localStartDay} #{localStartTime} - #{localEndTime}"
        else
          "#{localStartDay} #{localStartTime} - #{localEndDay} #{localEndTime}"

      showOriginalPriceFor: (lineItem) ->
        isSuperUser = @currentMemberIsSuperUser()
        isNotSamePrice = lineItem.total_original_price_in_dollars isnt @spacePriceFor(lineItem)
        isSuperUser && isNotSamePrice

      showOriginalPayoutFor: (lineItem) ->
        isSuperUser = @currentMemberIsSuperUser()
        isNotSamePayout = lineItem.total_original_payout_in_dollars isnt @spacePayoutFor(lineItem)
        isSuperUser && isNotSamePayout

      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      spaceFor: (lineItem) -> @eventForLineItem(lineItem).spaces[lineItem.space_name]
      spaceTypeFor: (lineItem) -> @spaceFor(lineItem)?.type
      spacePriceFor: (lineItem) -> lineItem.total_price_in_dollars
      spacePayoutFor: (lineItem) -> lineItem.total_payout_in_dollars

      navigateToDetails: (event) ->
        routeName = 'EventFeedDetails'
        routeName = 'CheckoutEventDetails' if @$route.name is 'CheckoutPage'
        @$router.push { name: routeName, params: { eventId: event.id } }

export default VueOptions.vue settings
